import { createGlobalStyle } from 'styled-components'
import vars from '../vars/vars'

export const DefaultStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
  }

  html {
    font-size: 10px;
    color: ${vars.COLOR_BLACK_1};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: ${vars.FONT_FAMILY_1};
    font-weight: ${vars.FONT_WEIGHT_REGULAR};
    background-color: ${vars.COLOR_BLACK_1};
  }

  body {
    font-size: 1.8rem;
  }

  html, body, #app {
    position: relative;
    height: 100%;
    width: 100%;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  select:focus {
    outline: none;
  }

  input::placeholder {
    color: ${vars.COLOR_GRAY_1};
  }

  // mobile input fix
  input, input:before, input:after {
    -webkit-user-select: initial;
    -khtml-user-select: initial;
    -moz-user-select: initial;
    -ms-user-select: initial;
    user-select: initial;
  }

  .plyr--video .plyr__control.plyr__tab-focus,
  .plyr--video .plyr__control:hover,
  .plyr--video .plyr__control[aria-expanded=true] {
    background: ${vars.COLOR_TURQUOISE_1} !important;
    opacity: 1 !important;
  }

  .plyr--full-ui input[type=range] {
    color: ${vars.COLOR_TURQUOISE_1} !important;
  }

  .plyr__control--overlaid {
    // display: none !important;
    background: ${vars.COLOR_TURQUOISE_1} !important;
    opacity: 0.8 !important;
  }

  .swiper-pagination {
    position: relative;
    display: flex;
  }

  .swiper-pagination-bullet {
    width: 13px;
    height: 13px;
    background: rgba(255, 255, 255, 0.4);
    margin-right: 10px;
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: ${vars.COLOR_WHITE_1};
  }

  img {
    display: block;
    pointer-events: none;
    user-select: none;
  }

  .fade-in-up {
    animation-name: fade-in-up;
  }

  @keyframes fade-in-up {
    from {
      opacity: 0;
      transform: translate3d(0, 20px, 0);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }
`
